import { createSlice } from "@reduxjs/toolkit";
import { FetchStatus } from "../../shared/redux.consts";
import { LoanDetailsState, LoanDetailsStore } from "../../types/loan-details";
import { fetchLoanDetails } from "./loan-details.thunk";

const initialLoanDetailsState: LoanDetailsState = {
  status: FetchStatus.IDLE,
  loanDetails: null,
};

export const loanDetailsSlice = createSlice({
  name: "loanDetails",
  initialState: initialLoanDetailsState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLoanDetails.pending, (state) => {
        state.status = FetchStatus.LOADING;
      })
      .addCase(fetchLoanDetails.fulfilled, (state, action) => {
        if (action.payload) {
          state.status = FetchStatus.SUCCESS;
          state.loanDetails = action.payload;
        } else {
          state.status = FetchStatus.FAILED;
          state.error = "loan details get failed";
        }
      })
      .addCase(fetchLoanDetails.rejected, (state, action) => {
        state.status = FetchStatus.FAILED;
        if (action.error?.message) {
          state.error = action.error.message;
        }
      });
  },
});

export default loanDetailsSlice.reducer;

export const selectLoanDetailsState = (store: LoanDetailsStore) =>
  store.loanDetailsState;
